<template>
  <div id="app">
    <Admin v-if="$store.state.isAdmin"/>
    <Theatre v-else/>
  </div>
</template>

<script>
import Theatre from './components/Theatre/Theatre.vue';
import Admin from './components/Admin/Admin.vue';
export default {
  name: 'app',
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue